import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  populationAggregationState: {},
  loadingAggregationsState: false,
  missingStates: []
}

const populationAggregationSlice = createSlice({
  name: 'populationAggregation',
  initialState,
  reducers: {
    setPopulationAggregationState: (state, action) => {
      state.populationAggregationState = action.payload
    },
    setLoadingAggregationsState: (state, action) => {
      state.loadingAggregationsState = action.payload
    },
    clearPopulationAggregation: (state) => {
      state.populationAggregationState = {}
      state.loadingAggregationsState = false
      state.missingStates = []
    },
    setMissingStates: (state, action) => {
      state.missingStates = action.payload
    }
  }
})

export const {
  setPopulationAggregationState,
  setLoadingAggregationsState,
  clearPopulationAggregation,
  setMissingStates
} = populationAggregationSlice.actions

export const selectPopulationAggregationState = (state) => state.populationAggregation.populationAggregationState
export const selectLoadingAggregationsState = (state) => state.populationAggregation.loadingAggregationsState
export const selectMissingStates = (state) => state.populationAggregation.missingStates

export default populationAggregationSlice.reducer
